import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/google-auth/:projectId/connect`;

export type ConnectGoogleDriveResponse = {
  state: string;
};

export const getConnectGoogleDriveUrl = (projectId: string | number) =>
  generateRoutePath(url, { projectId });

export const connectGoogleDrive = ({ projectId }): Promise<ConnectGoogleDriveResponse> => {
  const URL = getConnectGoogleDriveUrl(projectId);
  return axios.get(URL, { showError: false });
};

export const connectGoogleDriveQueryKey = ['connect-google-drive'];

type QueryFnType = typeof connectGoogleDrive;

type useEmailSignatureOptions = {
  projectId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useConnectGoogleDrive = ({ projectId, config }: useEmailSignatureOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...connectGoogleDriveQueryKey, projectId],
    queryFn: () => connectGoogleDrive({ projectId }),
    staleTime: Infinity,
    ...config,
  });
};
